module.exports = __webpack_public_path__ + "media/images/logo-900a21c492a453600b8f9fe80633075f.svg";